import React from 'react'

const DeletedMessage = () => {
    return <p style={{color: "#d92344", fontStyle: "italic"}}>This message was deleted</p>
}

export default DeletedMessage;